<template>
    <vx-elastic-suggest
        :value="localValue"
        v-bind="$attrs"
        v-on="listeners"
        ref="suggest"
        :search_groups="group"
        :clearable="clearable"
        select-like
        show-on-focus
        hide-group-title
        @keydown.tab.shift.prevent="tabBack"
        @keydown.tab.exact.prevent="tabNext"
    >
        <template #options="{ suggestion }">
            <slot name="option" :option="suggestion"> </slot>
        </template>
    </vx-elastic-suggest>
</template>

<script>
export default {
    name: 'vx-select',
    props: {
        value: {
            type: null
        },
        options: {
            type: Array,
            required: true,
            validator: (v) => v && v.allSameType()
        },
        valueKey: {
            type: [String, Function]
        },
        textKey: {
            type: [String, Function]
        },
        idKey: {
            type: [String, Function]
        },
        clearable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false
        }
    },
    computed: {
        localOptions() {
            if (!this.hasPrimitiveOptions) {
                return this.options
            }
            return this.options.map(this.createNonPrimitiveValue)
        },
        group() {
            return {
                options: {
                    idfield: this.getId,
                    searchOn: this.getText,
                    data: this.localOptions
                }
            }
        },
        hasPrimitiveOptions() {
            return this.options && this.options.any() && typeof this.options[0] !== 'object'
        },
        listeners() {
            return {
                ...this.$listeners,
                input: this.setValue
            }
        },
        getId() {
            if (this.hasPrimitiveOptions) {
                return this.convertGetter('id')
            }
            return this.convertGetter(this.idKey)
        },
        getValue() {
            if (this.hasPrimitiveOptions) {
                return this.convertGetter('id')
            }
            return this.convertGetter(this.valueKey)
        },
        getText() {
            if (this.hasPrimitiveOptions) {
                return this.convertGetter('text')
            }
            return this.convertGetter(this.textKey)
        },
        localValue: {
            get() {
                if (!this.value) {
                    return null
                }

                return this.localOptions.find((o) => this.getId(this.value) === this.getId(o))
            },
            set(val) {
                if (val) {
                    this.$emit('input', this.getValue(val))
                }
                if (this.clearable) {
                    this.$emit('input', null)
                }
            }
        }
    },
    methods: {
        createNonPrimitiveValue(o) {
            return {
                id: o,
                text: o ? String(o) : ''
            }
        },
        convertGetter(getter) {
            if (!getter) {
                return (item) => item
            }
            if (typeof getter === 'function') {
                return getter
            }
            return (item) => {
                if (item && typeof item === 'object') {
                    return item[getter]
                }
                return item
            }
        },
        setValue(val) {
            this.localValue = val
        },
        focus(e) {
            this.$refs.suggest.focus()
        },
        close() {
            this.$refs.suggest.close()
        }
    }
}
</script>
